import { useActive, useCommands } from "@remirror/react";
import { CommandMenuItem, DropdownButton } from "@remirror/react-ui";
import { useEffect } from "react";
import { TextProps } from "../../../../types";

const FONT_SIZES = [
  "8",
  "10",
  "12",
  "14",
  "16",
  "18",
  "24",
  "30",
  "40",
  "50",
  "60",
];

const ariaLabel = "Font size";

export const FontSizeButtons = ({ toggleButton, onBlur }: TextProps) => {
  const { setFontSize } = useCommands();
  const { fontSize } = useActive();
  const hasFontSize = FONT_SIZES.some((size) => fontSize({ size }));

  useEffect(() => {
    toggleButton({ shouldSelect: hasFontSize, ariaLabel });
  }, [hasFontSize, toggleButton]);

  return (
    <DropdownButton aria-label={ariaLabel} icon="fontSize">
      {FONT_SIZES.map((size) => (
        <CommandMenuItem
          key={size}
          commandName="setFontSize"
          onSelect={() => {
            setFontSize(size);
            onBlur();
          }}
          enabled={setFontSize.enabled(size)}
          active={fontSize({ size })}
          label={size}
          icon={null}
          displayDescription={false}
        />
      ))}
    </DropdownButton>
  );
};
